import apiClient from "./api";
const MUESTRAS_API_BASE_URL = "/muestras";
class MuestrasService {
    
async getMuestrasPorEstudio(estudioId) {
    try {
      const response = await apiClient.get(`${MUESTRAS_API_BASE_URL}/estudio/${estudioId}`,);
      return response.data.muestras;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new MuestrasService();